import {
    CREATE_GENERAL_PURCHASE_RETURN_BILL,
    DELETE_GENERAL_PURCHASE_RETURN_BILL,
    GET_GENERAL_PURCHASE_RETURN_BILLS,
    GET_GENERAL_PURCHASE_RETURN_BILLS_PAGE,
    GENERAL_PURCHASE_RETURN_BILL_REQUEST,
    GENERAL_PURCHASE_RETURN_BILL_REQUEST_SUCCESS,
    GENERAL_PURCHASE_RETURN_BILL_REQUEST_FAILURE,
    UPDATE_GENERAL_PURCHASE_RETURN_BILL
} from "../types";

const initialState = {
    generalPurchaseReturnBills: [],
    generalPurchaseReturnBillsPage: [],
    page: 1,
    pageSize: 10,
    search: '',
    where: {},
    total: 0,
    loading: false,
    error: null,
};

const generalPurchaseReturnBillReducer = (state = initialState, action) => {
switch (action.type) {
    case GENERAL_PURCHASE_RETURN_BILL_REQUEST: {
    return {
        ...state,
        loading: true,
        error: null
    }
    }
    case GET_GENERAL_PURCHASE_RETURN_BILLS: {
    return {
        ...state,
        generalPurchaseReturnBills: [...action.payload],
        loading: false,
        error: null
    }
    }
    case GET_GENERAL_PURCHASE_RETURN_BILLS_PAGE: {
        const { data, total, page, pageSize, search, where } = action.payload || {};
        return {
          ...state,
          generalPurchaseReturnBillsPage: [...data],
          total,
          page,
          pageSize,
          search: search || '',
          where: where || {},
          loading: false,
          error: null
        }
    }
    case CREATE_GENERAL_PURCHASE_RETURN_BILL:
    return {
        ...state,
        generalPurchaseReturnBills: [action.payload, ...state.generalPurchaseReturnBills],
        loading: false,
        error: null
    };
    case UPDATE_GENERAL_PURCHASE_RETURN_BILL:
    const generalPurchaseReturnBillsData = state.generalPurchaseReturnBills.slice(0);
    const uIndex = generalPurchaseReturnBillsData.findIndex((data) => data.id === action.payload.id);
    generalPurchaseReturnBillsData.splice(uIndex, 1, { ...action.payload.data });
    return {
        ...state,
        generalPurchaseReturnBills: [ ...generalPurchaseReturnBillsData ],
        loading: false,
        error: null
    };
    case DELETE_GENERAL_PURCHASE_RETURN_BILL:
    const generalPurchaseReturnBills = state.generalPurchaseReturnBills?.slice(0);
    const index = generalPurchaseReturnBills.findIndex((data) => data.id === action.id);
    if (index > -1) {
        generalPurchaseReturnBills.splice(index, 1);
    }
    return {
        ...state,
        generalPurchaseReturnBills: [...generalPurchaseReturnBills],
        loading: false,
        error: null
    }
    case GENERAL_PURCHASE_RETURN_BILL_REQUEST_SUCCESS: {
        return {
            ...state,
            loading: false,
            error: null
        }
    }
    case GENERAL_PURCHASE_RETURN_BILL_REQUEST_FAILURE: {
    return {
        ...state,
        loading: false,
        error: action.error
    }
    }
    default:
    return state;
}
};

export default generalPurchaseReturnBillReducer;
  